import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function LumusSection() {
  return (
    <section id="lumus" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in">
            <h2 className="text-4xl font-gilroy font-bold text-crop-black mb-6">
              Rastreabilidade ponta a ponta
            </h2>
            <p className="text-xl font-gilroy text-crop-dark mb-8 leading-relaxed">
              O sistema Lumus<span className="trademark">®</span> organiza todos os resultados por lote, linha e local de produção, 
              oferecendo anexos detalhados e trilhas de auditoria completas para garantir 
              conformidade regulatória e rastreabilidade total.
            </p>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-folder-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-2">
                    Organização por Lote
                  </h4>
                  <p className="font-gilroy text-crop-dark text-sm">
                    Resultados estruturados e categorizados para fácil acesso e consulta
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-file-text-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-2">
                    Trilhas de Auditoria
                  </h4>
                  <p className="font-gilroy text-crop-dark text-sm">
                    Registro completo de todas as etapas do processo analítico
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-8 h-8 bg-crop-teal/20 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-shield-check-line text-crop-black"></i>
                </div>
                <div>
                  <h4 className="font-gilroy font-semibold text-crop-black mb-2">
                    Conformidade Regulatória
                  </h4>
                  <p className="font-gilroy text-crop-dark text-sm">
                    Atendimento a requisitos normativos e padrões de qualidade
                  </p>
                </div>
              </div>
            </div>
            
            <a href="#contato">
              <Button size="lg">
                Conhecer o Lumus<span className="trademark">®</span>
              </Button>
            </a>
          </div>

          <Card className="animate-slide-up">
            <div className="bg-gray-100 rounded-lg overflow-hidden p-2">
              <img
                src="https://static.readdy.ai/image/91b17e0e4c4c5325a19775db74687ed5/aae8f152045c511e278947a816a337cd.jfif"
                alt="Interface do Sistema Lumus®"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}